export default __webpack_public_path__ + "src/assets/expand-purple.04521c82317cb37fa4d38c3295f3c07a.svg";